<template>
  <v-container fluid class="pa-0">
    <v-card class="v-card--material pa-3 ma-2 rounded-lg" elevation="2">
      <v-row no-gutters>
        <v-col cols="12" md="6" lg="4" sm="6" xs="12" class="my-0 py-0">
          <div class="d-flex grow flex-wrap">
            <div class="font-weight-regular headline text-decoration-underline text-capitalize">
              Center Category
            </div>
          </div>
        </v-col>
        <v-col>
            <v-card-actions>
              <router-link slot="right" :to="{ name: 'amsSchedulingDashboard' }">
                <v-btn
                  elevation="1"
                  absolute
                  right
                  top
                >
                  <v-icon left>mdi-arrow-left</v-icon>back</v-btn
                >
              </router-link>
            </v-card-actions>
          </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="2" sm="2" xs="12">
          <v-autocomplete
            key="id"
            :items="stateList"
            v-model="statename"
            item-value="state"
            item-text="state"
            @change="getCity(statename)"
          >
            <template v-slot:label> State </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="12" md="2" sm="2" xs="12">
          <v-autocomplete
            key="id"
            :items="cityList"
            v-model="cityname"
            item-value="city"
            item-text="city"
          >
            <template v-slot:label> City </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="12" md="2" sm="2" xs="12">
          <v-autocomplete
            key="id"
            :items="centerCategory"
            v-model="centerCategoryID"
            @change="changeFilter()"
            item-value="id"
            item-text="name"
          >
            <template v-slot:label> Center Category </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="12" md="2" sm="2" xs="12">
          <v-autocomplete
            name="id"
            :items="franchiseeList"
            v-model="franchiseeID"
            item-value="id"
            item-text="companyName"
          >
            <template v-slot:label> Center Name </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="12" md="2" sm="2" xs="12" v-if="isSuperAdmin === true">
          <v-autocomplete
            name="id"
            :items="zoneList"
            v-model="zoneID"
            item-value="id"
            item-text="name"
          >
            <template v-slot:label> Zone </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="12" md="2" lg="2" sm="2" xs="12">
          <div class="d-flex justify-end caption">
            <v-btn
              @click="getFranchiseeList()"
              small
              id="apply"
              color="success"
              elevation="1"
              type="submit"
              class="ml-2 mt-5"

            >
              <v-icon left size="18"> mdi-text-box-check-outline </v-icon>
              Filter
            </v-btn>
            <v-btn
              @click="clearData()"
              small
              elevation="1"
              type="reset"

              class="ml-2 mt-5"
            >
              <v-icon left size="18"> mdi-restart</v-icon> Clear
            </v-btn>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12" lg="12" sm="12" xs="12">
          <v-data-table
            item-key="id"
            :headers="headers"
            :items="franchiseeList"
          >
          <template v-slot:item.amsCenterCategory.name="{ item }">
              <span
                class="hoverable-span"
                small
                color="primary"
                @click="viewCenterCategoryJourney(item)"
              >
              {{ item.amsCenterCategory.name }}
              </span>
            </template>
            <template v-slot:item.view="{ item }">
              <v-btn
                small
                color="primary"
                @click="viewCenterDetails(item)"
              >
                <v-icon>mdi-eye</v-icon> View
              </v-btn>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-dialog
          persistent
          v-model="centerCategorypopup"
          max-width="800"
          :active="centerCategorypopup"
          :on-cancel="
            () => {
              ;(centerCategorypopup = false), clearData()
            }
          "
        >
        <v-card>
          <v-toolbar dark color="darkblue">
            <v-toolbar-title>Center Name : {{ centerCategoryDetails.companyName }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                icon
                dark
                @click="
                  () => {
                    ;(centerCategorypopup = false), clearData()
                  }
                "
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card class="v-card--material pa-3 ma-2 rounded-lg" elevation="2">
            <div>
              <v-data-table
                item-key="id"
                :headers="centerHeaders"
                :items="centerCategoryDetails.amsCategoryLogs"
              ></v-data-table>
            </div>
          </v-card>
        </v-card>
      </v-dialog>
      <v-dialog
          persistent
          v-model="viewDetailspopup"
          fullscreen
          transition="dialog-bottom-transition"
          :active="viewDetailspopup"
          :on-cancel="
            () => {
              ;(viewDetailspopup = false), clearData()
            }
          "
        >
        <v-card style="background-color: #C5C5C5">
          <v-toolbar dark color="darkblue" style="position: sticky; top: 0; z-index: 1;">
            <v-toolbar-title>Weightage Score & Center Category</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                icon
                dark
                @click="
                  () => {
                    ;(viewDetailspopup = false), clearData()
                  }
                "
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
        <div style="max-height: auto; overflow-y: auto;">
          <v-card class="v-card--material pa-3 ma-2 rounded-lg" elevation="2">
            <div v-if="centerCategoryState.name === 'Gold'"
              style="background-color:#ffbf00; height: 60px;"
              center-active
              dark
              align-with-title
            >
              <div class="text-center" style="font-size: 30px; color: white;">
                Center Category : {{ centerCategoryState.name }}
              </div>
            </div>
            <div v-if="centerCategoryState.name === 'Silver'"
                style="background-color:#c0c0c0; height: 60px;"
                center-active
                dark
                align-with-title
              >
              <div class="text-center" style="font-size: 30px; color: black;">
                Center Category : {{ centerCategoryState.name }}
              </div>
            </div>
            <div v-if="centerCategoryState.name === 'Bronze'"
                style="background-color:#CD7F32; height: 60px;"
                center-active
                dark
                align-with-title
              >
              <div class="text-center" style="font-size: 30px; color: white;">
                Center Category : {{ centerCategoryState.name }}
              </div>
            </div>
          </v-card>
          <div class="inside">
            <!-- <v-col cols="12" sm="6" md="4" lg="2"> -->
              <div style="height: 250px; width: 247px; margin: 5px;">
                <data-card
                  title="Retention Score"
                  :value="retentionScore"
                ></data-card>
              </div>
            <!-- </v-col> -->
            <!-- <v-col cols="12" sm="6" md="4" lg="2"> -->
              <div style="height: 250px; width: 247px; margin: 5px;">
              <data-card
                title="Total Strength Score"
                :value="strengthScore"
              ></data-card>
              </div>
            <!-- </v-col> -->
            <!-- <v-col cols="12" sm="6" md="4" lg="2"> -->
              <div style="height: 250px; width: 247px; margin: 5px;">
              <data-card
                title="Parents (NPS) Score"
                :value="parentsScore"
              ></data-card>
            </div>
            <!-- </v-col> -->
            <!-- <v-col cols="12" sm="6" md="4" lg="2"> -->
              <div style="height: 250px; width: 247px; margin: 5px;">
              <data-card
                title="Teacher Score"
                :value="teacherScore"
              >
              </data-card>
            </div>
            <!-- </v-col> -->
            <!-- <v-col cols="12" sm="6" md="4" lg="2"> -->
              <div style="height: 250px; width: 247px; margin: 5px;">
              <data-card
                title="Total Weightage Score"
                :value="weightageScore"
              >
              </data-card>
            </div>
            <!-- </v-col> -->
          </div>
          <!-- <div class="inside">
            <v-col cols="12" sm="6" md="4" lg="12">
              <data-card
                subIcon="mdi-calendar"
                subtitle="Till Today's Date"
                title="Total Weightage Score"
                :value="weightageScore"
              >
              </data-card>
            </v-col>
          </div> -->
          &nbsp;
          <v-container fluid>
    <!-- <v-data-iterator

      hide-default-footer
    > -->
      <template v-slot:header>
        <v-toolbar
          class="mb-2"
          color="indigo darken-5"
          dark
          flat
        >
          <v-toolbar-title>This is a header</v-toolbar-title>
        </v-toolbar>
      </template>

      <!-- <template v-slot:default="props"> -->
        <v-row>
          <v-col

            cols="12"
            sm="6"
            md="4"
            lg="6"
          >
            <v-card>
              <v-card-title style="background-color: #72A0C1; color:#fff" class="subheading text-white font-weight-bold text-center">
                {{ retentionObj.name }}
              </v-card-title>

              <v-list dense>
                <v-list-item>
                  <v-row>
                    <v-col cols="auto">Number of Students in last year (Excluding PP2)</v-col>
                    <v-col class="text-end" style="margin-right: 80px;">
                      {{ retentionObj.numberOfStudnetInLastYear }}
                    </v-col>
                  </v-row>
                </v-list-item>
                <span class="divider"></span>
                 <v-list-item>
                  <v-row>
                    <v-col cols="auto">Number of students retained</v-col>
                    <v-col class="text-end" style="margin-right: 80px;">
                      {{ retentionObj.numberOfStudentRetained }}
                    </v-col>
                  </v-row>
                </v-list-item>
                <span class="divider"></span>
                <v-list-item>
                  <v-row>
                    <v-col cols="auto">Retained %</v-col>
                    <v-col class="text-end" style="margin-right: 80px;">
                      {{ retentionObj.retainedPercentage }}
                    </v-col>
                  </v-row>
                </v-list-item>
                <span class="divider"></span>
                <v-list-item>
                  <v-row>
                    <v-col cols="auto">Retention Score</v-col>
                    <v-col class="text-end" style="margin-right: 80px;">
                      {{ retentionObj.retentionScore }}
                    </v-col>
                  </v-row>
                </v-list-item>
              </v-list>
            </v-card>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="4"
            lg="6"
          >
            <v-card>
              <v-card-title style="background-color: #72A0C1;  color:#fff" class="subheading font-weight-bold text-center">
                {{ totalStrengthObj.name }}
              </v-card-title>

               <v-list dense>
                <v-list-item>
                  <v-row>
                    <v-col cols="auto">Ideal Total Strength</v-col>
                    <v-col class="text-end" style="margin-right: 80px;">
                      {{ totalStrengthObj.idealTotalStrength }}
                    </v-col>
                  </v-row>
                </v-list-item>
                <span class="divider"></span>
                <v-list-item>
                  <v-row>
                    <v-col cols="auto">Current Strength</v-col>
                    <v-col class="text-end" style="margin-right: 80px;">
                      {{ totalStrengthObj.currentStrength }}
                    </v-col>
                  </v-row>
                </v-list-item>
                <span class="divider"></span>
                <v-list-item>
                  <v-row>
                    <v-col cols="auto">Strength %</v-col>
                    <v-col class="text-end" style="margin-right: 80px;">
                      {{ totalStrengthObj.strengthPercentage }}
                    </v-col>
                  </v-row>
                </v-list-item>
                <span class="divider"></span>
                <v-list-item>
                  <v-row>
                    <v-col cols="auto">Total Strength Score</v-col>
                    <v-col class="text-end" style="margin-right: 80px;">
                      {{ totalStrengthObj.totalStrengthScore }}
                    </v-col>
                  </v-row>
                </v-list-item>
              </v-list>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            sm="6"
            md="4"
            lg="6"
          >
            <v-card>
              <v-card-title style="background-color: #72A0C1;  color:#fff" class="subheading font-weight-bold text-center">
                {{ parentsNPSObj.name }}
              </v-card-title>

               <v-list dense>
                <v-list-item>
                  <v-row>
                    <v-col cols="auto">Total number of parents providing rating</v-col>
                    <v-col class="text-end" style="margin-right: 80px;">
                      {{ parentsNPSObj.totalNumberOfParentsRating }}
                    </v-col>
                  </v-row>
                </v-list-item>
                <span class="divider"></span>
                <v-list-item>
                  <v-row>
                    <v-col cols="auto">Number of Parents who gave rating 8,9 or 10</v-col>
                    <v-col class="text-end" style="margin-right: 80px;">
                      {{ parentsNPSObj.numberOfParentRating }}
                    </v-col>
                  </v-row>
                </v-list-item>
                <span class="divider"></span>
                <v-list-item>
                  <v-row>
                    <v-col cols="auto">Parents (NPS) %</v-col>
                    <v-col class="text-end" style="margin-right: 80px;">
                      {{ parentsNPSObj.parentNpsPercentage }}
                    </v-col>
                  </v-row>
                </v-list-item>
                <span class="divider"></span>
                <v-list-item>
                  <v-row>
                    <v-col cols="auto">Parents (NPS) Score</v-col>
                    <v-col class="text-end" style="margin-right: 80px;">
                      {{ parentsNPSObj.parentNpsScore }}
                    </v-col>
                  </v-row>
                </v-list-item>
              </v-list>
            </v-card>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="4"
            lg="6"
          >
            <v-card>
              <v-card-title style="background-color: #72A0C1;  color:#fff" class="subheading font-weight-bold text-center">
                {{ teachersObj.name }}
              </v-card-title>

               <v-list dense>
                <v-list-item>
                  <v-row>
                    <v-col cols="auto">Teachers %</v-col>
                    <v-col class="text-end" style="margin-right: 80px;">
                      {{ teachersObj.teacherPercentage }}
                    </v-col>
                  </v-row>
                </v-list-item>
                <span class="divider"></span>
                <v-list-item>
                  <v-row>
                    <v-col cols="auto">Teachers Score</v-col>
                    <v-col class="text-end" style="margin-right: 80px;">
                      {{ teachersObj.teacherScore }}
                    </v-col>
                  </v-row>
                </v-list-item>
              </v-list>
            </v-card>
          </v-col>
        </v-row>
      <!-- </template> -->
    <!-- </v-data-iterator> -->
          </v-container>
        </div>
        </v-card>
      </v-dialog>
    </v-card>
  </v-container>

</template>

<script>
import constants from '@/utils/constants'
import stores from '@/stores'
import DataCard from '@/components/template/DataCard'
import moment from 'moment'

export default {
  name: 'centerCategory',
  components: { DataCard },
  data () {
    return {
      headers: [
        {
          text: 'Center Name',
          value: 'companyName',
          sortable: true,
          align: 'center'
        },
        {
          text: 'Zone',
          value: 'region',
          sortable: true,
          align: 'center'
        },
        {
          text: 'State',
          value: 'state',
          sortable: true,
          align: 'center'
        },
        {
          text: 'City',
          value: 'city',
          sortable: true,
          align: 'center'
        },
        {
          text: 'Center Category',
          value: 'amsCenterCategory.name',
          sortable: true,
          align: 'center'
        },
        {
          text: 'View Details',
          value: 'view',
          align: 'center'
        }
      ],
      centerHeaders: [
        {
          text: 'Date and Time',
          value: 'createdAt',
          sortable: true,
          align: 'center'
        },
        {
          text: 'Center Category',
          value: 'amsCenterCategory.name',
          sortable: true,
          align: 'center'
        }
      ],
      stateList: [],
      statename: '',
      cityList: [],
      cityname: '',
      centerCategory: [],
      centerCategoryID: '',
      zmUserId: '',
      franchiseeNameList: [],
      franchiseeID: '',
      franchiseeList: [],

      centerCategorypopup: false,
      centerCategoryDetails: '',
      viewCenter: false,
      viewCenterAllDetails: '',
      isSuperAdmin: false,
      isCompo: null,
      viewDetailspopup: false,

      retentionScore: '00',
      strengthScore: '00',
      parentsScore: '00',
      teacherScore: '00',
      weightageScore: '00',

      itemsPerPage: 4,
      retentionObj: {
        name: 'Retention',
        numberOfStudnetInLastYear: '',
        numberOfStudentRetained: '',
        retainedPercentage: '',
        retentionScore: ''
      },
      totalStrengthObj: {
        name: 'Total Strength',
        currentStrength: '',
        strengthPercentage: '',
        totalStrengthScore: '',
        idealTotalStrength: ''
      },
      parentsNPSObj: {
        name: 'Parents (NPS)',
        numberOfParentRating: '',
        totalNumberOfParentsRating: '',
        parentNpsPercentage: '',
        parentNpsScore: ''
      },
      teachersObj: {
        name: 'Teachers',
        teacherPercentage: '',
        teacherScore: ''
      },
      centerCategoryState: '',
      amUserId: '',
      AMS_ZonalManager: false,
      AMS_AreaManager: false,

      zoneList: [
        { id: 'south', name: 'South' },
        { id: 'north', name: 'North' },
        { id: 'west', name: 'West' },
        { id: 'east', name: 'East' }
      ],
      zoneID: ''
    }
  },
  created: async function () {
    let userStore = stores.user
    this.isSuperAdmin = userStore.ACL.superAdmin
    if (this.isSuperAdmin === false) {
      if (userStore.roles[0].role === 'AMS_ZonalManager') {
        this.AMS_ZonalManager = true
        this.zmUserId = userStore.me.id
      }
      if (userStore.roles[0].role === 'AMS_AreaManager') {
        this.AMS_AreaManager = true
        this.amUserId = userStore.me.id
      }
    }
    console.log(userStore, 'userStore------------')

    await this.getState()
    await this.getCenterCategory()
    await this.getFranchiseeList()
  },
  methods: {
    getState: async function () {
      try {
        const response = await http.get(
          `${constants.API_URL}/api/amsScheduling/centerCategory/getStateList`
        )
        this.stateList = response.data
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.$dialog.notify.info(errorMessage, {
          position: 'top-right',
          color: 'error',
          timeout: 2000
        })
      }
    },
    getCity: async function (statename) {
      try {
        if (statename !== '') {
          console.log(statename, 'statename--')

          const response = await http.post(
            `${constants.API_URL}/api/amsScheduling/centerCategory/getCityList`,
            {
              'stateName': statename === null ? '' : statename
            }
          )
          this.cityList = response.data
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.$dialog.notify.info(errorMessage, {
          position: 'top-right',
          color: 'error',
          timeout: 2000
        })
      }
    },
    getCenterCategory: async function () {
      try {
        const response = await http.get(
          `${constants.API_URL}/api/amsScheduling/centerCategory/getCenterCategory`
        )
        this.centerCategory = response.data
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.$dialog.notify.info(errorMessage, {
          position: 'top-right',
          color: 'error',
          timeout: 2000
        })
      }
    },
    changeFilter () {
      this.franchiseeID = ''
    },
    getFranchiseeList: async function () {
      try {
        let payload = {}
        if (this.AMS_ZonalManager === true) {
          payload.zmUserId = this.zmUserId
        }
        if (this.AMS_AreaManager === true) {
          payload.amUserId = this.amUserId
        }
        if (this.isSuperAdmin) {
          payload.zone = this.zoneID == null ? '' : this.zoneID
        }
        payload.franchiseeId = this.franchiseeID === null ? '' : this.franchiseeID
        payload.categoryId = this.centerCategoryID === null ? '' : this.centerCategoryID
        payload.city = this.cityname === null ? '' : this.cityname
        payload.state = this.statename == null ? '' : this.statename

        const response = await http.post(
          `${constants.API_URL}/api/amsScheduling/centerCategory/getFranchiseeList`, payload
        )
        this.franchiseeList = response.data
        for (const item of this.franchiseeList) {
          item.amsCenterCategory = item.amsCenterCategory === null ? ' ' : item.amsCenterCategory
        }
        console.log(this.franchiseeList, '----')
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.$dialog.notify.info(errorMessage, {
          position: 'top-right',
          color: 'error',
          timeout: 2000
        })
      }
    },

    viewCenterCategoryJourney (item) {
      console.log(item)

      this.centerCategorypopup = true
      this.centerCategoryDetails = item
      for (const item of this.centerCategoryDetails.amsCategoryLogs) {
        item.createdAt = moment(item.createdAt).format('DD/MM/YYYY HH:MM')
      }
    },
    viewCenterDetails: async function (item) {
      try {
        this.viewCenter = true
        const response = await http.post(
          `${constants.API_URL}/api/amsScheduling/centerCategory/getFranchiseeDetails`,
          {
            'franchiseeId': item.id
          }
        )
        console.log(response, 'response')

        this.viewCenterAllDetails = response.data
        console.log(this.viewCenterAllDetails, 'this.viewCenterAllDetails')
        if (this.viewCenterAllDetails === '') {
          this.viewDetailspopup = false
        } else {
          this.viewDetailspopup = true
          this.retentionScore = this.viewCenterAllDetails.retentionScore
          this.strengthScore = this.viewCenterAllDetails.totalStrengthScore
          this.parentsScore = this.viewCenterAllDetails.parentNpsScore
          this.teacherScore = this.viewCenterAllDetails.teacherScore
          this.weightageScore = this.viewCenterAllDetails.totalWeightageScore

          this.retentionObj.numberOfStudnetInLastYear = this.viewCenterAllDetails.numberOfStudnetInLastYear ? this.viewCenterAllDetails.numberOfStudnetInLastYear : 0
          this.retentionObj.numberOfStudentRetained = this.viewCenterAllDetails.numberOfStudentRetained ? this.viewCenterAllDetails.numberOfStudentRetained : 0
          this.retentionObj.retainedPercentage = this.viewCenterAllDetails.retainedPercentage ? this.viewCenterAllDetails.retainedPercentage : 0
          this.retentionObj.retentionScore = this.viewCenterAllDetails.retentionScore ? this.viewCenterAllDetails.retentionScore : 0

          this.totalStrengthObj.idealTotalStrength = this.viewCenterAllDetails.franchisee.idealTotalStrength ? this.viewCenterAllDetails.franchisee.idealTotalStrength : 0
          this.totalStrengthObj.currentStrength = this.viewCenterAllDetails.currentStrength ? this.viewCenterAllDetails.currentStrength : 0
          this.totalStrengthObj.strengthPercentage = this.viewCenterAllDetails.strengthPercentage ? this.viewCenterAllDetails.strengthPercentage : 0
          this.totalStrengthObj.totalStrengthScore = this.viewCenterAllDetails.totalStrengthScore ? this.viewCenterAllDetails.totalStrengthScore : 0

          this.parentsNPSObj.numberOfParentRating = this.viewCenterAllDetails.numberOfParentRating ? this.viewCenterAllDetails.numberOfParentRating : 0
          this.parentsNPSObj.totalNumberOfParentsRating = this.viewCenterAllDetails.totalNumberOfParentsRating ? this.viewCenterAllDetails.totalNumberOfParentsRating : 0
          this.parentsNPSObj.parentNpsPercentage = this.viewCenterAllDetails.parentNpsPercentage ? this.viewCenterAllDetails.parentNpsPercentage : 0
          this.parentsNPSObj.parentNpsScore = this.viewCenterAllDetails.parentNpsScore ? this.viewCenterAllDetails.parentNpsScore : 0

          this.teachersObj.teacherPercentage = this.viewCenterAllDetails.teacherPercentage
          this.teachersObj.teacherScore = this.viewCenterAllDetails.teacherScore

          this.centerCategoryState = this.viewCenterAllDetails.franchisee.amsCenterCategory
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.$dialog.notify.info(errorMessage, {
          position: 'top-right',
          color: 'error',
          timeout: 2000
        })
      }
    },
    clearData () {
      this.centerCategorypopup = false
      this.centerCategoryDetails = ''
      this.viewCenter = false
      this.viewDetailspopup = false

      this.franchiseeID = ''
      this.centerCategoryID = ''
      this.cityname = ''
      this.statename = ''
      this.zoneID = ''
      this.getFranchiseeList()
    }
  }
}

</script>

<style scoped>
.hoverable-span {
  cursor: pointer; /* Change the cursor to a pointer to indicate clickability */
  color: #000; /* Default text color */
  transition: color 0.3s; /* Smooth transition for the color change */
}

.hoverable-span:hover {
  color: blue; /* Change text color to blue on hover */
}

.text-center {
  display: flex;
  justify-content: center; /* Center the text horizontally */
  align-items: center;     /* Center the text vertically if needed */
  height: 100%;            /* Ensure full height to apply centering */
}

.divider{
  background-color: grey;
    border: none;
    display: block;
    height: 1px;
    margin: 1px;
}
</style>
